import React from 'react';
import styles from './Navbar.module.css';
import iconMap from './icons/iconMap';

const SidebarButton = ({
  text,
  icon,
  buttonClassName = '',
  textClassName = '',
  iconClassName = '',
}) => {
  const IconComponent = iconMap[icon];

  return (
    <button className={`${styles.sadrzajMainDugme} ${buttonClassName}`}>
      {IconComponent && (
        <IconComponent
          className={`${styles.sadrzajMainDugmeIkonica} ${iconClassName}`}
        />
      )}
      <span
        className={`${styles.sadrzajMainDugmeTekst} ${textClassName} ${styles.specialFont}`}
      >
        {text}
      </span>
    </button>
  );
};

export default SidebarButton;
